import React from 'react';
import { useTranslation } from 'react-i18next';
function AboutOptions(props) {
  const { t } = useTranslation();
  return (
    <>
      <div id="hide-about" className="about-options-container">
        <p
          style={{ margin: 0 }}
          onClick={() => {
            props.navigateTo('aboutSection');
            document.querySelector('#hide-about').id = 'hide-about-after';
            setTimeout(() => {
              document.querySelector('#hide-about-after').id = 'hide-about';
            }, 1000);
          }}
        >
          {t('sections-NavBar-AboutOptions-Team')}
        </p>
        <p
          style={{ margin: 0 }}
          onClick={() => {
            props.navigateTo('demo');
            document.querySelector('#hide-about').id = 'hide-about-after';
            setTimeout(() => {
              document.querySelector('#hide-about-after').id = 'hide-about';
            }, 1000);
          }}
        >
          {t('sections-NavBar-AboutOptions-Testimonial')}
        </p>
        <p
          style={{ margin: 0 }}
          onClick={() => {
            props.navigateTo('clients');
            document.querySelector('#hide-about').id = 'hide-about-after';
            setTimeout(() => {
              document.querySelector('#hide-about-after').id = 'hide-about';
            }, 1000);
          }}
        >
          {t('sections-NavBar-AboutOptions-Clients')}
        </p>
        <p
          style={{ margin: 0 }}
          onClick={() => {
            props.navigateTo('footer');
            document.querySelector('#hide-about').id = 'hide-about-after';
            setTimeout(() => {
              document.querySelector('#hide-about-after').id = 'hide-about';
            }, 1000);
          }}
        >
          {t('sections-NavBar-AboutOptions-Contact')}
        </p>
      </div>
    </>
  );
}

export default AboutOptions;
